export default function initPageFeedbackButtons() {
    const buttons = document.querySelectorAll<HTMLButtonElement>( 'button[data-feedback]' );

    buttons.forEach( ( btn: HTMLButtonElement ) => {
        btn.addEventListener( 'click', () => {
            buttons.forEach( ( b ) => {
                b.disabled = true;

                if ( b.dataset.feedback === btn.dataset.feedback ) {
                    b.classList.add( 'clicked' );
                } else {
                    b.classList.remove( 'clicked' );
                }
            } );
        } );
    } );
}
